import Client from './index'
import * as Predicates from './utils/predicates'
import * as Types from '@avcan/prismic/types'
import * as Utils from './utils'

export function getForecast(date = new Date(), locale) {
    const predicate = Predicates.field(
        Types.WEATHER_FORECAST,
        'date',
        Utils.formatToDateString(date)
    )

    return Client.queryFirst(predicate, { locale })
}

export function getTutorial(uid, locale) {
    const predicate = Predicates.uid(Types.WEATHER_TUTORIAL, uid)

    return Client.queryFirst(predicate, { locale })
}
